import * as React from 'react';
import { ArticleHeading2 } from '@cian/ui-kit';
import { getStandardFeatureContainerSize } from '../../../../utils/getStandardFeatureContainerSize';
import classNames from 'classnames';

import * as styles from './styles.css';

interface IOfferListProps {
  title: string;
  offersLength: number;
  offers: React.ReactNode[];
}

export function OfferList({ title, offersLength, offers }: IOfferListProps) {
  return (
    <div className={styles['container']} style={{ width: getStandardFeatureContainerSize(offersLength) }}>
      <div className={styles['title']}>
        <ArticleHeading2>{title}</ArticleHeading2>
      </div>
      <div className={classNames(styles['list'], offersLength % 2 !== 0 && styles['list--odd'])}>{offers}</div>
    </div>
  );
}
